import { _createNewNotification } from "./_createNotification";
import { _getRealTimeNotifications } from "./_getRealTimeNotifications";

export default class QueryDB_Notifications {
  constructor() {}
  static createNewNotification = _createNewNotification;
  static getRealtimeNotifications = _getRealTimeNotifications;
}
